import { render, staticRenderFns } from "./WarningBadge.vue?vue&type=template&id=2f02fb53&scoped=true"
import script from "./WarningBadge.vue?vue&type=script&lang=js"
export * from "./WarningBadge.vue?vue&type=script&lang=js"
import style0 from "./WarningBadge.vue?vue&type=style&index=0&id=2f02fb53&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f02fb53",
  null
  
)

export default component.exports